<section class="cmn-innerpage-wrapper quotation-new">
  <h2 class="cmn-inner-heading">
    {{ quoteId ? "Update Quotation" : "New Quotation" }}
  </h2>
  <form [formGroup]="quoteForm">
    <div class="invoice-new-form-wrapper">
      <div class="form-wrapper invoice-form-wrapper">
        <div class="cmn-Search-select-container">
          <label for="clientName"
            >Customer Name <span class="red">*</span></label
          >
          <mat-form-field>
            <mat-select
              placeholder="Search Customer"
              formControlName="customerId"
              (selectionChange)="onCustomerSelected($event)"
            >
              <mat-option>
                <ngx-mat-select-search
                  [placeholderLabel]="'Search'"
                  [noEntriesFoundLabel]="'No options found'"
                  (input)="onSearch($event)"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let partner of partnersData"
                [value]="partner.id"
              >
                {{ partner.firstName + " " + partner.lastName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  quoteForm.get('customerId')!.touched &&
                  quoteForm.get('customerId')!.hasError('required')
                "
                >Customer is required.</mat-error
              >
            </span>
          </div>
          <button [routerLink]="'/customers/customer-new'">
            <div>
              <img
                src="../../../assets/images/icons/icon-add-color.svg"
                alt="Add client"
              />
            </div>
            <span>Add customer</span>
          </button>
        </div>
        <div>
          <label for="">Project Name<span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              placeholder="Enter Project Name"
              formControlName="projectName"
              maxlength="50"
            />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  quoteForm.get('projectName')!.touched &&
                  quoteForm.get('projectName')!.hasError('required')
                "
                >Project Name is required.</mat-error
              >
            </span>
          </div>
        </div>
        <div>
          <label for="">Lead Name <span class="red">*</span></label>
          <mat-form-field>
            <mat-select
              placeholder="Select project"
              formControlName="leadId"
              #singleSelect2
            >
              <mat-option *ngFor="let lead of leadData" [value]="lead.id">
                {{ lead.leadName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  quoteForm.get('leadId')!.touched &&
                  quoteForm.get('leadId')!.hasError('required')
                "
                >Lead is required.</mat-error
              >
            </span>
          </div>
        </div>
        <div>
          <label for="">Quote Code <span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              placeholder="Quote Code"
              formControlName="quoteCode"
              maxlength="30"
            />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  quoteForm.get('quoteCode')!.touched &&
                  quoteForm.get('quoteCode')!.hasError('required')
                "
                >Quote code is required.</mat-error
              >
            </span>
          </div>
        </div>
        <div>
          <label for="">Quote Date <span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="quoteDatePicker1"
              placeholder="Select Date"
              formControlName="quoteDate"
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="quoteDatePicker1"
            ></mat-datepicker-toggle>
            <mat-datepicker #quoteDatePicker1></mat-datepicker>
          </mat-form-field>

          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  quoteForm.get('quoteDate')!.touched &&
                  quoteForm.get('quoteDate')!.hasError('required')
                "
                >Quote date is required.</mat-error
              >
            </span>
          </div>
        </div>
        <div>
          <label for="">Valid Until</label>
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="quoteDatePicker2"
              placeholder="Select Date"
              formControlName="validUntil"
              [matDatepickerFilter]="disableBeforeQuoteDate"
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="quoteDatePicker2"
            ></mat-datepicker-toggle>
            <mat-datepicker #quoteDatePicker2></mat-datepicker>
          </mat-form-field>
        </div>
        <div>
          <label for="">Branch Name <span class="red">*</span></label>
          <mat-form-field>
            <mat-select
              placeholder="Select branch"
              formControlName="branchId"
              [disabled]="isBranchReadOnly"
            >
              <mat-option *ngFor="let branch of branchData" [value]="branch.id">
                {{ branch.branchName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="custom-error">
            <span
              ><mat-error
                *ngIf="
                  quoteForm.get('branchId')!.touched &&
                  quoteForm.get('branchId')?.hasError('branchInvalid')
                "
              >
                Branch is required
              </mat-error>
            </span>
          </div>
        </div>

        <div>
          <label for="paymentTerm">Payment Term</label>
          <mat-form-field>
            <input
              matInput
              placeholder="Payment Term"
              id="paymentTerm"
              formControlName="paymentTerms"
            />
          </mat-form-field>
        </div>

        <div class="form-wrapper full-width-form">
          <label class="checkbox-wrapper">
            <input type="checkbox" formControlName="isPriority" />Is Priority
            <span class="checkmark"></span>
          </label>
          </div>

        <!-- <div>
          <label for="approvalDate">Approval Date</label>
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="quoteDatePicker3"
              placeholder="Select Date"
              formControlName="approvalDate"
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="quoteDatePicker3"
            ></mat-datepicker-toggle>
            <mat-datepicker #quoteDatePicker3></mat-datepicker>
          </mat-form-field>
          <mat-error
            *ngIf="
              quoteForm.get('approvalDate')?.hasError('validityDateInvalid')
            "
          >
            Validity Date cannot be before Quote Date
          </mat-error>
        </div> -->
      </div>
    </div>
    <div class="item-service-adding-table-wrapper" formArrayName="items">
      <table>
        <thead>
          <tr>
            <th>Service <span class="red">*</span></th>
            <th>Quantity <span class="red">*</span></th>
            <th>Unit <span class="red">*</span></th>
            <th>Price <span class="red">*</span></th>
            <th>ETA <span class="red">*</span></th>
            <th>Net Amount <span class="red">*</span></th>
          </tr>
        </thead>

        <tbody>
          <tr
            *ngFor="let item of items.controls; let i = index"
            [formGroupName]="i"
          >
            <!-- Service data -->
            <td>
              <div class="form-wrapper">
                <mat-form-field>
                  <mat-select
                    placeholder="Select a service"
                    formControlName="serviceId"
                    (selectionChange)="onServiceChange($event.value, i)"
                  >
                    <mat-option
                      *ngFor="let service of serviceData"
                      [value]="service.id"
                    >
                      {{ service.serviceName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <div class="custom-error">
                  <span>
                    <mat-error
                      *ngIf="
                        item.get('serviceId')?.touched &&
                        item.get('serviceId')?.hasError('required')
                      "
                      >Service is required.</mat-error
                    >
                  </span>

                  <span>
                    <mat-error
                      *ngIf="item.get('quantity')?.hasError('nonNegative')"
                      >Quantity cannot be negative.</mat-error
                    >
                  </span>
                </div>
              </div>
            </td>
            <!-- Quantity data -->
            <td>
              <div class="form-wrapper">
                <mat-form-field>
                  <input
                    matInput
                    placeholder="Quantity"
                    formControlName="quantity"
                    readonly
                  />
                </mat-form-field>

                <div class="custom-error">
                  <span>
                    <mat-error
                      *ngIf="
                        item.get('quantity')?.touched &&
                        item.get('quantity')?.hasError('required')
                      "
                      >Quantity is required.</mat-error
                    >
                  </span>

                  <span>
                    <mat-error
                      *ngIf="item.get('quantity')?.hasError('nonNegative')"
                      >Quantity cannot be negative.</mat-error
                    >
                  </span>
                </div>
              </div>
            </td>
            <!-- unit data -->
            <td>
              <div class="form-wrapper min-width-field">
                <mat-form-field>
                  <mat-select
                    placeholder="Choose unit"
                    formControlName="unit"
                    maxlength="7"
                    aria-readonly="true"
                  >
                    <mat-option
                      *ngFor="let unit of unitTypes"
                      [value]="unit.value"
                    >
                      {{ unit.value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <div class="custom-error">
                  <span>
                    <mat-error
                      *ngIf="
                        item.get('unit')!.touched &&
                        item.get('unit')!.hasError('required')
                      "
                      >Unit is required.</mat-error
                    >
                  </span>
                </div>
              </div>
            </td>
            <!-- rate data -->
            <td>
              <div class="form-wrapper">
                <mat-form-field>
                  <input
                    matInput
                    placeholder="0.00"
                    formControlName="rate"
                    type="number"
                    readonly
                  />
                </mat-form-field>
                <div class="custom-error">
                  <span>
                    <mat-error
                      *ngIf="
                        item.get('rate')?.touched &&
                        item.get('rate')?.hasError('required')
                      "
                      >Price is required.</mat-error
                    >
                  </span>
                  <span>
                    <mat-error *ngIf="item.get('rate')?.hasError('nonNegative')"
                      >Price cannot be negative.</mat-error
                    >
                  </span>
                  <span>
                    <mat-error *ngIf="item.get('rate')?.hasError('invalidRate')"
                      >Price cannot be 0.</mat-error
                    >
                  </span>
                </div>
              </div>
            </td>
            <td>
              <div class="form-wrapper">
                <mat-form-field>
                  <input
                    matInput
                    placeholder="0.00"
                    formControlName="eta"
                    type="number"
                    readonly
                  />
                </mat-form-field>
              </div>
            </td>
            <!--  amount data -->
            <td>
              <div class="form-wrapper">
                <mat-form-field>
                  <input
                    matInput
                    [value]="getItemTotalAmount(item.value)"
                    formControlName="amount"
                    readonly
                  />
                </mat-form-field>
                <span class="delete">
                  <img
                    src="../../../assets/images/icons/icon-close.svg"
                    alt="Delete"
                    (click)="onRemoveNewlyAddedItems(i)"
                  />
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <button type="button" (click)="addItem()">
        <img src="../../../assets/images/icons/icon-add-color.svg" alt="Add" />
        Add Item
      </button>
    </div>

    <div
      class="quotation-table-container"
      *ngIf="quoteData?.quoteItems?.length > 0"
    >
      <div>
        <table>
          <thead>
            <tr>
              <th>Service Name</th>
              <th>Quantity</th>
              <th>Unit</th>
              <th>Price</th>
              <th>ETA</th>
              <th>Net Amount</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody *ngIf="quoteData">
            <tr *ngFor="let item of calculatedItems; let i = index">
              <td>{{ item.serviceData?.serviceName }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.unit }}</td>
              <td>{{ item.rate }}</td>
              <td>{{ item.eta }}</td>
              <td>{{ item.amount }}</td>
              <td (click)="onRemoveQuoteItem(i, item?.id)">
                <img
                  src="assets/images/icons/icon-delete.svg"
                  alt="Delete Item"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="invoice-new-form-wrapper">

      <div class="form-wrapper invoice-form-wrapper">
        <div>
          <label for="discountType">Discount Type</label>
          <mat-form-field>
            <mat-select
              placeholder="Select a type"
              formControlName="discountType"
            >
              <mat-option value="Fixed">Fixed</mat-option>
              <mat-option value="Percentage">Percentage</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
  
        <div>
          <label for="discount">Discount</label>
          <mat-form-field>
            <input
              matInput
              placeholder="Discount"
              type="number"
              id="discount"
              formControlName="discount"
            />
          </mat-form-field>
          <mat-error *ngIf="quoteForm.get('discount')?.hasError('maxDiscount')">
            Discount cannot exceed 100%.
          </mat-error>
        </div>
        
        <div>
          <label for="discount">Discount Value</label>
          <mat-form-field>
            <input
              matInput
              placeholder="Discount"
              type="number"
              id="discountValue"
              formControlName="discountValue"
              readonly
            />
          </mat-form-field>
        </div>
        <div>
          <label for="discountReason">Discount Reason</label>
          <mat-form-field>
            <input
              matInput
              placeholder="Discount"
              id="discountReason"
              formControlName="discountReason"
            />
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="notes-tatal-amount-container">
      <div class="form-container">
        <div class="form-wrapper">
          <label for="notes">Notes</label>
          <mat-form-field>
            <textarea matInput placeholder="Enter notes" formControlName="notes"></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="amount-table-div">
        <div>
          <h6>
            SubTotal<span
              >: AED {{ getSubTotalAmount() | number : "1.2-2" }}</span
            >
          </h6>
          <h6>
            Total Discount(-)<span
              >: AED {{ discount | number : "1.2-2" }}</span
            >
          </h6>
          <h6>
            VAT (5%)<span>: AED {{ getTotalVat() | number : "1.2-2" }}</span>
          </h6>
        </div>
        <div>
          <h4>
            Total<span>: AED {{ getTotalAmount() | number : "1.2-2" }}</span>
          </h4>
        </div>
      </div>
    </div>

    <div class="submit-btn-wrapper">
      <button class="cmn-cancel-btn" type="button" (click)="onCancel()">
        Cancel
      </button>
      <button
        class="cmn-draft-btn"
        type="button"
        (click)="saveAsDraft()"
        [disabled]="loading"
      >
        <span *ngIf="!loading">Save As Draft</span>
        <span *ngIf="loading">Loading...</span>
      </button>
      <button
        class="cmn-next-btn"
        type="button"
        (click)="saveAndSend()"
        [disabled]="loading"
      >
        <span *ngIf="!loading">Save and Send</span>
        <span *ngIf="loading">Loading...</span>
      </button>
    </div>
  </form>
</section>
